<template>
  <div class="mb-start-string" :class="isAnonimousForm ? 'anonimous' : null">
    <transition name="slide-checkprint">
      <div v-if="showCheckprint" class="modal-checkprint">
        <div class="checkprint-header">
          <h4 class="checkprint-title">Формирование цены</h4>
          <button class="close-button" @click="toggleCheckprint()">
            <img src="/images/redesignedForm/close-button.svg" alt="Закрыть" />
          </button>
        </div>
        <table class="checkprint-table" v-if="advanceCheque.length">
          <tbody>
            <tr v-for="(item, index) in advanceCheque" :key="index">
              <td :class="{ discount: item.red }">{{ item.name }}</td>
              <td :class="{ discount: item.red }">
                {{ `${item.value} ${item.value === 'Бесплатно' ? '' : '₽'}` }}
              </td>
            </tr>
          </tbody>
        </table>
        <Spinner v-else />
      </div>
    </transition>
    <template v-if="!isAnonimousForm">
      <button class="info" @click="toggleModals('templates', true)">
        <div class="icon-save"></div>
      </button>
      <button v-if="!base.isEdit" class="info" @click="toggleModals('favouriteCouriers')">
        <img src="/images/redesignedForm/courier-white.svg" alt="courier" />
      </button>
    </template>
    <button v-if="!isCrmCourierChosen" class="info" @click="toggleCheckprint">
      <Spinner v-if="isFormFetching" />
      <div class="price-container" v-else>
        <LightningIcon color="white" v-if="isHighDemand && !isAnonimousForm" />
        <LightningIcon v-else-if="isHighDemand" />
        <i v-else-if="isAnonimousForm">
          <font-awesome-icon icon="fas fa-info-circle" />
        </i>
        <img v-else src="/images/redesignedForm/info-white.svg" alt="info" />
        <span>{{ totalPrice }} ₽</span>
      </div>
    </button>
    <button
      @click="submitOrder()"
      class="start"
      :disabled="isFormFetching"
      :class="{ 'button-disabled': isFormFetching }"
    >
      <Spinner v-if="isFormFetching" />
      <span v-else> {{ orderText }} </span>
    </button>
    <city-select v-show="0" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import LightningIcon from '@/components/Icons/LightningIcon.vue'
import Spinner from '@features/UI/FontAwesomeSpinner.vue'
import CitySelect from './Aside/CitySelect.vue'

export default {
  name: 'BottomComponent',
  data: () => ({
    showCheckprint: false,
  }),
  components: {
    Spinner,
    LightningIcon,
    CitySelect,
  },
  computed: {
    ...mapState(GENERAL_STORE, ['base', 'isFormFetching', 'advanceCheque', 'isHighDemand']),
    ...mapGetters(GENERAL_STORE, ['totalPrice', 'isAnonimousForm', 'isCrmCourierChosen']),
    orderText() {
      if (this.base.isEdit) {
        return this.isAnonimousForm ? 'Сохранить заказ' : 'Сохранить'
      }

      return this.isAnonimousForm ? 'Запустить заказ' : 'Запустить'
    },
  },
  methods: {
    ...mapActions(GENERAL_STORE, ['submitOrder']),
    ...mapMutations(GENERAL_STORE, ['toggleModals']),
    toggleCheckprint() {
      this.showCheckprint = !this.showCheckprint
    },
  },
}
</script>

<style lang="scss" scoped>
.lightning-icon {
  width: 16px;
  height: 16px;
}

.non-high-demand-container {
  display: flex;
}

.discount {
  color: #fc6110 !important;
}

.app-loader {
  padding-top: 30%;
  padding-bottom: 30%;

  background-color: #fff;
}

.start {
  transition: background-color 0.3s;
}

.button-disabled {
  background-color: grey !important;

  /* cursor: not-allowed; */
}

.slide-checkprint-enter-active,
.slide-checkprint-leave-active {
  transition: all 0.5s ease-out;
}

.slide-checkprint-enter,
.slide-checkprint-leave-to {
  transform: translateY(25px);

  opacity: 0;
}

.modal-checkprint {
  position: absolute;
  z-index: 10;
  bottom: 100%;

  width: calc(100% - 30px);
  padding: 5px 5px 0;

  background-color: #050608;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  .checkprint-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    padding: 5px;

    color: #fff;

    .checkprint-title {
      display: inline-block;

      width: 90%;

      text-align: center;
    }

    .close-button {
      display: inline-block;

      font-size: 1.5rem;

      background-color: transparent;

      transition: opacity 0.4s ease;

      &:hover {
        opacity: 0.75;
      }
    }
  }

  .checkprint-table {
    border-collapse: collapse;

    width: 100%;

    tbody {
      background-color: #fff;

      td {
        padding: 10px;

        color: black;

        border: 1px solid #dee2e6;
      }
    }
  }
}
.price-container {
  display: flex;
  align-items: center;
}
</style>
